import { Button } from "devextreme-react/button";
import { formatMessage } from "devextreme/localization";
import { handleExportExcel } from "../../../common";

function ToolbarAfter({
  handleOpenPopup,
  selectedItems,
  middleware,
  dataGrid,
  isDisable,
}) {
  return (
    <div className="form_select_box_list">
      {middleware && middleware.ExportState && (
        <Button
          icon={`<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.6667 8.66667V12C12.6667 12.3667 12.3667 12.6667 12 12.6667H4C3.63333 12.6667 3.33333 12.3667 3.33333 12V8.66667C3.33333 8.3 3.03333 8 2.66667 8C2.3 8 2 8.3 2 8.66667V12.6667C2 13.4 2.6 14 3.33333 14H12.6667C13.4 14 14 13.4 14 12.6667V8.66667C14 8.3 13.7 8 13.3333 8C12.9667 8 12.6667 8.3 12.6667 8.66667ZM8.66667 8.44667L9.92 7.19333C10.18 6.93333 10.6 6.93333 10.86 7.19333C11.12 7.45333 11.12 7.87333 10.86 8.13333L8.46667 10.5267C8.20667 10.7867 7.78667 10.7867 7.52667 10.5267L5.13333 8.13333C4.87333 7.87333 4.87333 7.45333 5.13333 7.19333C5.39333 6.93333 5.81333 6.93333 6.07333 7.19333L7.33333 8.44667V2.66667C7.33333 2.3 7.63333 2 8 2C8.36667 2 8.66667 2.3 8.66667 2.66667V8.44667Z" fill="#000000"/></svg>`}
          text={formatMessage("Export")}
          onClick={() => handleExportExcel(dataGrid, "LeaveRegistration")}
          className="mr-1"
        />
      )}
      {middleware && middleware.ApproveState && (
        <div>
          <Button
            type="default"
            stylingMode="outlined"
            text={formatMessage("Approve")}
            className="button-rounded mr-2"
            onClick={() => {
              const newDataApprove = {
                items: [...selectedItems],
                type: 1,
                category: "TK",
              };
              handleOpenPopup(newDataApprove);
            }}
            disabled={isDisable}
            icon="check"
          />
          <Button
            type="danger"
            stylingMode="outlined"
            text={formatMessage("Reject")}
            className="button-rounded mr-2"
            icon="close"
            disabled={isDisable}
            onClick={() => {
              const newDataReject = {
                items: [...selectedItems],
                type: 0,
                category: "TK",
              };
              handleOpenPopup(newDataReject);
            }}
          />
        </div>
      )}
      <Button
        icon="revert"
        text={formatMessage("Refresh")}
        className="mr-1"
        onClick={() => dataGrid.current.instance.refresh()}
      />
    </div>
  );
}

export default ToolbarAfter;
